import { get } from 'lodash'
import { axiosInstance } from './api'
import * as ActionTypes from '../store/ActionTypes'

// The redux setup is not working and dispatch does not save data in the store
// for that reason whe use a callbacks

export const actionCreators = {
    getRedemptionCodes: redemptionGroups => ({
        type: ActionTypes.getRedemptionCodes,
        payload: redemptionGroups,
    }),
    getRedemptionClubs: redemptionClubs => ({
        type: ActionTypes.getRedemptionClubs,
        payload: redemptionClubs,
    }),
    getRedemptionBranches: redemptionBranches => ({
        type: ActionTypes.getRedemptionBranches,
        payload: redemptionBranches,
    }),
}

export const getRedemptionGroups = async ({
    callback = () => { },
    filter = undefined,
    pageSize = 10,
    currentPage = 0,
    orderBy = 'createdDate',
    descending = true,
}) => {
    if (currentPage !== 0)
        currentPage = currentPage - 1;
    const url = `RedemptionGroup/GetRedemptionGroupsByFilterPaginatedAsync?${filter ? `filter=${filter}&` : ''
        }${`pageNumber=${currentPage}&`}${`pageSize=${pageSize}&`}${`orderBy=${orderBy}&`}${`descending=${descending}`}`
    try {
        const redemptionGroupsData = await axiosInstance().get(url)
        callback(redemptionGroupsData.data.data)

        return dispatch => {
            dispatch(actionCreators.getRedemptionCodes(redemptionGroupsData.data.data))
        }
    } catch (error) {
        callback({ results: [] })
        return error
    }
}

export const getRedemptionBranches = async ({ callback = () => { } }) => {
    try {
        const url = `Branch/GetAllBranches`
        const redemptionBranchesData = await axiosInstance().get(url)
        callback([{ name: '', branchId: '' }, ...redemptionBranchesData.data.data])
        return dispatch => {
            dispatch(actionCreators.getRedemptionBranches(redemptionBranchesData.data.data))
        }
    } catch (error) {
        callback({ results: [] })
        return error
    }
}

export const getRedemptionProducts = async ({ callback = () => { }, branchId = 0 }) => {
    if (!branchId) return callback({})
    try {
        const url = `Product/GetProductsAsync?branchId=${branchId}`
        const redemptionProductData = await axiosInstance().get(url)
        callback([{ name: '', productId: '' }, ...redemptionProductData.data.data])

        return dispatch => {
            dispatch(actionCreators.getRedemptionBranches(redemptionProductData.data.data))
        }
    } catch (error) {
        callback({ results: [] })
        return error
    }
}

export const createRedemptionCodes = async ({
    callback = () => { },
    redemptionData = {},
    errorCallback = () => { },
}) => {
    try {
        const url = `RedemptionGroup/PostAsync`
        const redemptionResponse = await axiosInstance().post(url, redemptionData)
        callback({ ...redemptionResponse.data.data })
        return null
    } catch (error) {
        const errorsArray = (get(error, 'response.data.errors') || []).map(
            errorApi => get(errorApi, 'message') || ''
        )
        errorCallback(errorsArray)
        return error
    }
}

export const updateRedemptionGroup = async ({
    callback = () => { },
    redemptionData = {},
    errorCallback = () => { },
}) => {
    try {
        const url = `RedemptionGroup/PutAsync`
        const redemptionResponse = await axiosInstance().put(url, redemptionData)
        callback({ ...redemptionResponse.data.data })
        return null
    } catch (error) {
        const errorsArray = (get(error, 'response.data.errors') || []).map(
            errorApi => get(errorApi, 'message') || ''
        )
        errorCallback(errorsArray)
        return error
    }
}

export const getRedemptionCodesById = async ({
    callback = () => { },
    id = undefined,
    pageSize = 10,
    currentPage = 0,
    orderBy = 'createdDate',
    descending = true,
    errorCallback = () => { },
}) => {
    if (currentPage !== 0)
        currentPage = currentPage - 1;
    const url = `RedemptionGroup/GetRedemptionCodesByFilterPaginatedAsync?${id ? `id=${id}&` : ''
        }${`pageNumber=${currentPage}&`}${`pageSize=${pageSize}&`}${`orderBy=${orderBy}&`}${`descending=${descending}&`}`
    try {
        const redemptionCodesData = await axiosInstance().get(url)
        callback(redemptionCodesData.data.data)
        return null
    } catch (error) {
        const errorsArray = (get(error, 'response.data.errors') || []).map(
            errorApi => get(errorApi, 'message') || ''
        )
        callback({ results: [] })
        errorCallback(errorsArray)
        return error
    }
}

export const getBranchById = async ({
    callback = () => { },
    id = undefined,
}) => {
    console.log(id, callback);
    const url = `Branch/GetBranchById/${id}`
    try {
        console.log("redemptionCodesApi");
        const branchData = await axiosInstance().get(url)
        callback(branchData.data.data)
        return null
    } catch (error) {
        const errorsArray = (get(error, 'response.data.errors') || []).map(
            errorApi => get(errorApi, 'message') || ''
        )
        callback({ branch: null })
        errorCallback(errorsArray)
        return error
    }
}

export const getMaxRedemptionCodesQuantity = async ({ callback = () => { } }) => {
    const url = 'AppSettings/GetRedemptionCodeMaxQty'
    try {
        const {
            data: {
                value: { maxCodesQuantity },
            },
        } = await axiosInstance().get(url)
        callback(maxCodesQuantity)
        return null
    } catch (error) {
        callback(10000)
        return error
    }
}

export const getRedemptionCodeUsageReport = (clubId, branchId, redemptionName, status, startDate, endDate) => {
    const url = `RedemptionGroup/GetRedemptionCodeReport?clubId=${+clubId > 0 ? clubId : ''}&branchId=${+branchId > 0 ? branchId : ''}&groupName=${redemptionName}&status=${status}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getRedemptionCodesByIdReport = (id) => {
    const url = `RedemptionGroup/GetRedemptionCodesReportById?id=${id}`;
    return axiosInstance().get(url);
}

